import { Box, Stack, useTheme } from "@mui/material";
import { ScoreComparisonCard } from "src/components/Actions/Tabs/ScoreComparisonCard";
import { useActionsContext } from "src/context/Actions/useActionsContext";

type SynthesisCardsProps = unknown;
export const SynthesisCards = (_props: SynthesisCardsProps) => {
    const theme = useTheme();
    const { scoresEnabled, allScoreWithVariations, scoreOptions, actionPlanData, actionPlanMetadata } =
        useActionsContext();

    return (
        <Stack flexDirection={"row"} flexWrap={"wrap"} gap={theme.spacing(1)}>
            {scoresEnabled.map((score) => {
                const scoreOpts = allScoreWithVariations.filter(
                    (scoreVariation) => scoreVariation.group === score.title,
                );
                const selectedScore = scoreOpts.find((filteredScore) => {
                    const variationId = scoreOptions.selectedVariations[score.id];
                    const doesVariationMatch = variationId === filteredScore.variationId;
                    const doesScoreMatch = score.id === filteredScore.scoreId;
                    if (variationId === undefined) {
                        return doesScoreMatch;
                    }

                    return doesScoreMatch && doesVariationMatch;
                });

                if (scoreOpts.length === 0) return;
                const selectedOption = selectedScore ?? scoreOpts[0];

                const _actionPlanData = actionPlanData.find((i) => {
                    return i.scoreId === selectedOption.scoreId && i.variationId === selectedOption.variationId;
                });
                if (_actionPlanData === undefined) return;

                actionPlanMetadata.isGrowthDisabled;

                return (
                    <Box
                        key={`score-synthesis-${selectedOption.scoreId}-${selectedOption.variationId}`}
                        sx={{
                            display: "flex",
                            width: "49%",
                            flexDirection: "column",
                        }}
                    >
                        <ScoreComparisonCard
                            position={"horizontal"}
                            allOptions={scoreOpts}
                            actionPlanData={_actionPlanData}
                            selectedOption={selectedOption}
                            precision={score.precision}
                            disableFooter
                        />
                    </Box>
                );
            })}
        </Stack>
    );
};
